export * from './lib/promotions.module';
